export default {
    getLayout: state => {
        return state.layout
    },
    getUobj: state => {
        return state.uobj
    },
    getNavigate: state => {
        return state.navigate
    },
    getFCMT: state => {
        return state.fcmt
    },
    ringing : state => state.ringing,
    getNotificationCount : state => state.notificationCount,
    getNotifications : state => state.notifications,
    callStatus: state => state.callStatus,
    videocallPayload: state => state.videocallPayload,
    videoMinimised: state => state.minimised,
    getSocket: state => state.socket,
}
